import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CallState {
  inCall: boolean
  callId: string | null
  callType: 'voice' | 'video' | null
  remoteUserId: string | null
  micEnabled: boolean
  videoEnabled: boolean
  screenShareEnabled: boolean
  loading: boolean
  error: string | null
}

const initialState: CallState = {
  inCall: false,
  callId: null,
  callType: null,
  remoteUserId: null,
  micEnabled: true,
  videoEnabled: true,
  screenShareEnabled: false,
  loading: false,
  error: null,
}

const callSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    startCall: (state, action: PayloadAction<{ callType: 'voice' | 'video'; remoteUserId: string }>) => {
      state.inCall = true
      state.callType = action.payload.callType
      state.remoteUserId = action.payload.remoteUserId
      state.loading = true
    },
    callConnected: (state, action: PayloadAction<string>) => {
      state.callId = action.payload
      state.loading = false
    },
    endCall: (state) => {
      state.inCall = false
      state.callId = null
      state.callType = null
      state.remoteUserId = null
      state.micEnabled = true
      state.videoEnabled = true
      state.screenShareEnabled = false
    },
    toggleMic: (state) => {
      state.micEnabled = !state.micEnabled
    },
    toggleVideo: (state) => {
      state.videoEnabled = !state.videoEnabled
    },
    toggleScreenShare: (state) => {
      state.screenShareEnabled = !state.screenShareEnabled
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const { startCall, callConnected, endCall, toggleMic, toggleVideo, toggleScreenShare, setError } =
  callSlice.actions

export default callSlice.reducer
